'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KlaviyoCollectionAtcEvent = function () {
  function KlaviyoCollectionAtcEvent(el) {
    (0, _classCallCheck3.default)(this, KlaviyoCollectionAtcEvent);

    this.els = {
      el: el,
      form: (0, _functional.getElement)('.js-AddToCart', { context: el }),
      variants: (0, _functional.getElement)('.js-Product_Variants', { context: el })
    };
    this.onSubmit = this.onSubmit.bind(this);
    if (this.els.variants) {
      this.els.variants.addEventListener('click', this.onSubmit);
    } else if (this.els.form) {
      this.els.form.addEventListener('submit', this.onSubmit);
    }
  }

  (0, _createClass3.default)(KlaviyoCollectionAtcEvent, [{
    key: 'onSubmit',
    value: function onSubmit() {
      // eslint-disable-next-line no-undef
      _learnq.push(['track', 'Added to Cart', this.data]);

      // Emit an event.
      window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }
  }, {
    key: 'data',
    get: function get() {
      return {
        Name: this.els.el.dataset.name,
        ProductID: this.els.el.dataset.id,
        Categories: this.els.el.dataset.category,
        ImageURL: this.els.el.dataset.image,
        URL: this.els.el.dataset.url,
        Brand: this.els.el.dataset.brand,
        Price: this.els.el.dataset.price,
        CompareAtPrice: this.els.el.dataset.comparePrice
      };
    }
  }]);
  return KlaviyoCollectionAtcEvent;
}();

exports.default = KlaviyoCollectionAtcEvent;